import { ColorType } from './color-types.model';

export interface ColorConfig {
  allowColorPicker?: boolean;
  colorPalette?: ColorType[];
  colorPickerColumnDef?: string;
}
